export class CustomerRequest{
    custId : number;
    
    constructor(custId : number)
    {
        this.custId = custId;
        
    }
}
